import { useDispatch, useSelector } from "react-redux";

import { CONTACTS_SEARCH_RESULTS_LOWER_LIMIT } from "app/pages/sales-intelligence/modules/company-analysis/constants/contacts";
import { getSelectedContactDetailsType } from "app/pages/sales-intelligence/modules/company-analysis/helpers/contacts";
import companyAnalysisTrackingService from "app/pages/sales-intelligence/modules/company-analysis/services/tracking/companyAnalysisTrackingService";
import {
    contactDetailsSelectedAction,
    contactsTableFiltersChangedAction,
} from "app/pages/sales-intelligence/modules/company-analysis/store/contacts/action-creators";
import { selectContactDetails } from "app/pages/sales-intelligence/modules/company-analysis/store/contacts/selectors";
import {
    selectContactsResultsAreBeingFetched,
    selectNumberOfContactsSearchResults,
} from "app/pages/sales-intelligence/sub-modules/contacts-search/store/selectors";
import { selectLoadingContactStatus } from "app/pages/sales-intelligence/sub-modules/contacts-tab/store/selectors";
import { CONTACTS_DETAILS_LIST } from "app/pages/sales-intelligence/sub-modules/contacts-search/constants/actions-panel";
import type { ContactDetails } from "app/pages/sales-intelligence/sub-modules/contacts-search/types/common";
import { ContactDetail } from "app/pages/sales-intelligence/sub-modules/contacts-search/types/enums";

import ContactDetailsDropdown from "./ContactDetailsDropdown";
import { CONTACTS_SEARCH_TABLE_INITIAL_PAGE } from "app/pages/sales-intelligence/sub-modules/contacts-search/constants/table";

const ContactDetailsDropdownContainer = () => {
    const dispatch = useDispatch();
    const selectedContactDetails = useSelector(selectContactDetails);
    const isLoadingContactsResults = useSelector(selectContactsResultsAreBeingFetched);
    const isLoadingContactStatus = useSelector(selectLoadingContactStatus);
    const numberOfSearchResults = useSelector(selectNumberOfContactsSearchResults);

    function handleSelect(type: ContactDetail | null) {
        if (type !== null && numberOfSearchResults > CONTACTS_SEARCH_RESULTS_LOWER_LIMIT) {
            companyAnalysisTrackingService.contacts.trackContactDetailsValueSelected(type);
        }

        const contactDetails: ContactDetails = {};

        switch (type) {
            case ContactDetail.Email:
                contactDetails.hasEmail = true;
                break;
            case ContactDetail.MobilePhone:
                contactDetails.hasMobilePhone = true;
                break;
            case ContactDetail.DirectPhone:
                contactDetails.hasDirectPhone = true;
                break;
            case ContactDetail.EmailAndMobilePhone:
                contactDetails.hasEmailAndMobilePhone = true;
                break;
            default:
                break;
        }

        dispatch(contactDetailsSelectedAction(contactDetails));
        dispatch(
            contactsTableFiltersChangedAction({
                page: CONTACTS_SEARCH_TABLE_INITIAL_PAGE,
            }),
        );
    }

    function handleOpen() {
        if (numberOfSearchResults > CONTACTS_SEARCH_RESULTS_LOWER_LIMIT) {
            companyAnalysisTrackingService.contacts.trackContactDetailsDropdownOpened();
        }
    }

    function handleClose() {
        if (numberOfSearchResults > CONTACTS_SEARCH_RESULTS_LOWER_LIMIT) {
            companyAnalysisTrackingService.contacts.trackContactDetailsDropdownClosed();
        }
    }

    return (
        <ContactDetailsDropdown
            isDisabled={isLoadingContactStatus || isLoadingContactsResults || numberOfSearchResults === 0}
            types={CONTACTS_DETAILS_LIST}
            selectedType={getSelectedContactDetailsType(selectedContactDetails)}
            onSelect={handleSelect}
            onOpen={handleOpen}
            onClose={handleClose}
        />
    );
};

export default ContactDetailsDropdownContainer;
